@if (isLoading) {
  <div class="flex justify-center">
    <p-progress-spinner />
  </div>
} @else {

<div class="p-4">
  <p-accordion [multiple]="true">
    @for (content of welcomeContent; track content.sectionTitle; let i = $index) {
      <p-accordion-panel class="mb-4" [value]="content.sectionTitle">
        <p-accordion-header>{{ content.sectionTitle }}</p-accordion-header>
        <p-accordion-content>
          <!-- ALERTS -->
          @if (alertContent[i].length) {
            <p-accordion [multiple]="true" [(value)]="alertActivePanels[i]">
              <p-accordion-panel class="mb-4" value="alerts">
                <p-accordion-header>Alerts</p-accordion-header>
                <p-accordion-content>
                  <p-accordion [multiple]="true" [(value)]="itemActivePanels[i]">
                    @for (wc of alertContent[i]; track wc.welcomeContentId) {
                      <p-accordion-panel class="mb-2" [value]="wc.welcomeContentId">
                        <p-accordion-header>
                          <div class="header-content">
                            @if (wc.isCritical) {
                              <i class="pi pi-exclamation-triangle alert-icon"></i>
                            }
                            <span>
                              {{ wc.title }}
                            </span>
                          </div>
                        </p-accordion-header>
                        <p-accordion-content>
                          <div class="pt-2">
                            <app-show-more-html [html]="wc.content" />
                          </div>
                          <div class="pt-2">
                            <p-checkbox
                              name="attestCheckbox"
                              [binary]="true"
                              [ngModel]="wc.isAttested"
                              [disabled]="wc.isAttested"
                              (onChange)="onCheckboxClick($event,wc,content,i)" />
                            <label class="ml-2">I attest that I have read the message</label>
                          </div>
                        </p-accordion-content>
                      </p-accordion-panel>
                    }
                  </p-accordion>
                </p-accordion-content>
              </p-accordion-panel>
            </p-accordion>
          }

          <!-- NON ALERTS -->
          <div class="grid grid-cols-12 gap-4">
            @for (wc of nonAlertContent[i]; track wc.welcomeContentId) {
              <div class="col-span-6 p-3 border border-gray-300 rounded-sm">
                @if (wc.contentTypeName === 'Welcome Page') {
                  <header class="font-bold text-lg pb-3">Welcome {{ userName }}</header>
                } @else {
                  <header class="font-bold text-lg pb-3">{{ wc.contentTypeName }}</header>
                }
                <app-show-more-html [html]="wc.content" />
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</div>
}